"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
export default function Deferred(t0) {
  const $ = _c(4);
  const {
    children
  } = t0;
  const [isMounted, setIsMounted] = useState(false);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const requestIdle = (globalThis as any).requestIdleCallback || _temp;
      const cancelIdle = (globalThis as any).cancelIdleCallback || _temp2;
      const id_0 = requestIdle(() => setIsMounted(true));
      return () => cancelIdle(id_0);
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  if (!isMounted) {
    return null;
  }
  let t3;
  if ($[2] !== children) {
    t3 = <>{children}</>;
    $[2] = children;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}
function _temp2(id) {
  return clearTimeout(id);
}
function _temp(cb) {
  return setTimeout(cb, 1);
}